import debounce from 'lodash/debounce';
import {
  scrollToElement
} from '@/utils';

const focusInput = parentNode => {
  // first check a user is not typing in an input box
  if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'SELECT') {
    return;
  }

  // check a field error actually exists
  const fieldError = parentNode.querySelector('.field-error');
  if (!fieldError) {
    return;
  }

  // scroll to the element if its not currently focused
  const fieldParent = fieldError.parentNode;
  const field = fieldParent.querySelector('input, select');
  const isFocused = document.activeElement === field;
  if (!isFocused) {
    scrollToElement(fieldParent);
  }
};

const inputErrorFocus = targetNode => {
  const targetFocusInput = debounce(focusInput.bind(null, targetNode), 50);

  const observer = new MutationObserver(mutationsList => {
    for (const mutation of mutationsList) {
      if (mutation.addedNodes.length) {
        const elementNodes = [...mutation.addedNodes].filter(el => el.nodeType === 1);
        const fieldError = elementNodes.find(el => el.classList && el.classList.contains('field-error'));
        if (fieldError) {
          targetFocusInput();
        }
      }
    }
  });

  observer.observe(targetNode, {
    childList: true,
    subtree: true
  });
};

export default inputErrorFocus;